/**
 * @desc getTaxonomy
 */
const URL = "/rantion-walmart";
import http, { updateResponse } from "@/http";
export function request(params: API.walmart.test.getTaxonomy.Params, options?: any) {
  return updateResponse(
    http(URL + `/test/getTaxonomy`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
